export const isUnitTestEnv = process.env.NODE_ENV === 'test';
